import {useRef} from 'react';
import {withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap';
import {Button, Form, Input,} from 'antd';
import {setGlobalSpinner} from '../../services/redux/actions/GeneralAction';
import Api from '../../services/Api';
import HelperGeneral from '../../helpers/HelperGeneral';
import UserInfo from "../auth/UserInfo";

const {TextArea} = Input;

const Contact = () => {
    const formRef = useRef(null);

    const onFinishSalesFilter = (values) => {
        setGlobalSpinner(true);
        const data = {
            form_id: 6,
            form_data: {
                contact_name: values?.firstName,
                contact_lastname: values?.lastName,
                contact_email: values?.email,
                contact_message: values?.message,
            }
        };

        Api.createCommunication(data).then((e) => {
            setGlobalSpinner(false);
            formRef.current?.resetFields();
            HelperGeneral.alert("Mesajınız başarılı bir şekilde iletilmiştir.", "success");
        }).catch(e => {
            HelperGeneral.alert(e);
            setGlobalSpinner(false);
        })
    }

    return (
        <div className={'my-account basket product-category info pb-2 pb-sm-5 min-height-container'}>
            <Container>
                <Row>
                    <Col xs={12}>
                        <h4>İletişim</h4>
                        <Breadcrumb>
                            <Breadcrumb.Item href={"/home"}>Ana Sayfa</Breadcrumb.Item>
                            <Breadcrumb.Item>İletişim</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col xs={12} md={6} className={'mt-1 mt-sm-4 d-flex'}>
                        <div className={'product-history'}>
                            <h4>İletişim Formu</h4>
                            <p>Düşüncelerinizi önemsiyoruz! İstek, öneri ve görüşlerinizi aşağıdaki form aracılığıyla kolayca bize iletebilirsiniz.</p>
                            <Form
                                layout={'vertical'}
                                ref={formRef}
                                initialValues={{
                                    firstName: UserInfo.info('first_name'),
                                    lastName: UserInfo.info('last_name'),
                                    email: UserInfo.info('email'),
                                }}
                                onFinish={(e) => {
                                    return onFinishSalesFilter(e)
                                }}
                            >
                                <Row>
                                    <Col xs={12} md={6}>
                                        <Form.Item
                                            label={'Ad'}
                                            name={"firstName"}
                                            rules={[
                                                {
                                                    required: false,
                                                },
                                            ]}
                                        >
                                            <Input disabled={true}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Item
                                            label={'Soyad'}
                                            name={"lastName"}
                                            rules={[
                                                {
                                                    required: false,
                                                },
                                            ]}
                                        >
                                            <Input disabled={true}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Item
                                            label={"E-posta Adresiniz"}
                                            name={"email"}
                                            rules={[
                                                {
                                                    required: false,
                                                    type: 'email',
                                                },
                                            ]}
                                        >
                                            <Input disabled={true}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Item
                                            label={"Mesajınız"}
                                            name={"message"}
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                            ]}
                                        >
                                            <TextArea rows={4}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={8} md={3} className={'mx-auto'}>
                                        <Form.Item>
                                            <Button
                                                type={"primary"}
                                                className={'btn text-white btn-primary w-100'}
                                                style={{
                                                    border: 'none',
                                                    borderRadius: 3,
                                                    height: 46,
                                                }}
                                                htmlType={'submit'}
                                            >
                                                Gönder
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Col>
                    <Col xs={12} md={6} className={'mt-4 d-flex'}>
                        <div className={'product-history'}>
                            <h4 className={"mb-4"}>İletişim Bilgileri</h4>
                            <b>İşletme Adı</b>
                            <hr/>
                            <p>Orzaks İlaç ve Kimya San. Tic. A.Ş.</p>
                            <b>Adres</b>
                            <hr/>
                            <p>Esentepe Mah. Büyükdere Cad. No:171 Metrocity İş Merkezi A Blok Kat:1 Şişli/İstanbul</p>
                            <b>Telefon</b>
                            <hr/>
                            <p>0212 447 47 37</p>
                            <b>E-Posta</b>
                            <hr/>
                            <p>info@shiniq.com</p>
                            <b>Mersis No</b>
                            <hr/>
                            <p>0648-0595-4660-0014</p>
                        </div>
                    </Col>
                    <Col xs={12} className={'mt-4 d-flex'}>
                        <div className={'product-history w-100'}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.6613662580503!2d29.01119277686496!3d41.07639421522647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa583066406ff%3A0x7c129f9a9e7342ff!2zT3J6YWtzIMSwbGHDpw!5e0!3m2!1str!2str!4v1749557701098!5m2!1str!2str"
                                height="400"
                                frameBorder="0"
                                style={{width: '100%'}}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default withRouter(Contact)
